// Nacin placanja racuna.
//
// Sifre dolaze iz UBL-a (cbc:PaymentMeansCode, lista UNCL4461) pa ih ne treba
// pogadjati - eRacun sam kaze je li placen gotovinom ili karticom. Rucno
// unesen racun (papirnati slip s benzinske, Lidl, Plodine) dobiva istu oznaku
// kroz izbornik na racunu.
//
//   placeno  - racun je vec podmiren u trenutku izdavanja
//   virman   - treba li za njega napraviti nalog za placanje

const NACINI = [
  { oznaka: 'transakcijski', naziv: 'Transakcijski račun', sifra: '30', placeno: false, virman: true },
  { oznaka: 'gotovina', naziv: 'Gotovina', sifra: '10', placeno: true, virman: false },
  { oznaka: 'kartica', naziv: 'Kartica', sifra: '48', placeno: true, virman: false },
  { oznaka: 'online', naziv: 'Online plaćanje', sifra: '68', placeno: true, virman: false },
  { oznaka: 'terecenje', naziv: 'Izravno terećenje', sifra: '49', placeno: false, virman: false },
  { oznaka: 'ostalo', naziv: 'Ostalo', sifra: '1', placeno: false, virman: true }
]

// UBL sifra -> nasa oznaka. Sve neprepoznato je transakcijski racun, jer je to
// jedini nacin kod kojeg se placanje tek treba napraviti.
const PO_SIFRI = {
  '10': 'gotovina',
  '48': 'kartica',
  '54': 'kartica',
  '55': 'kartica',
  '68': 'online',
  '49': 'terecenje',
  '59': 'terecenje'
}

const nadji = (oznaka) => NACINI.find(n => n.oznaka === oznaka) || NACINI[0]

// Nacin placanja iz UBL sifre.
const nacinIzSifre = (sifra) => {
  const cista = String(sifra === null || sifra === undefined ? '' : sifra).trim()
  if (cista.length === 0) { return nadji('transakcijski') }
  return nadji(PO_SIFRI[cista] ? PO_SIFRI[cista] : 'transakcijski')
}

const nacinPoOznaci = (oznaka) => nadji(oznaka)

// Naziv za prikaz u listi i na ispisu.
const nazivNacina = (sifra) => nacinIzSifre(sifra).naziv

// Racun je podmiren i kad sifra to ne kaze, ako dobavljac iskaze da je cijeli
// iznos vec placen (PrepaidAmount pokriva iznos s PDV-om).
const vecPodmiren = (sifra, iznosSPdvom, vecPlaceno) => {
  if (nacinIzSifre(sifra).placeno) { return true }
  const ukupno = parseFloat(iznosSPdvom) || 0
  const placeno = parseFloat(vecPlaceno) || 0
  return ukupno > 0 && placeno >= ukupno - 0.01
}

const nacini = () => NACINI.map(n => ({...n}))

export {
  nacini,
  nacinIzSifre,
  nacinPoOznaci,
  nazivNacina,
  vecPodmiren
}
